/* Info-Sprechblase am Loesungs-Punkt.

   Ueberarbeitet 20.08.2026: Die Blase haengt jetzt an position:fixed und wird
   vom JS in Viewport-Koordinaten platziert. Grund: vorher war sie absolut
   positioniert und lief in das overflow-x:clip von .smelu-mech__inner - auf
   schmalen Containern war der Text dadurch seitlich abgeschnitten. Mit fixed
   kann kein Vorfahre mehr beschneiden.

   Verhalten: oeffnet nach oben, klappt nach unten wenn oben kein Platz ist,
   wird horizontal in den Viewport geklemmt, der Pfeil zeigt weiterhin auf den
   Kreis. Beim Scrollen und bei Resize schliesst sie, damit sie nicht
   irgendwo im Bild stehen bleibt. */
(function () {
  'use strict';

  var PAD = 12;   // Mindestabstand zum Viewport-Rand
  var GAP = 9;    // Abstand zwischen Kreis und Blase

  function tipOf(wrap) { return wrap.querySelector('.smelu-mech__infobox'); }

  function closeAll(except) {
    document.querySelectorAll('[data-smelu-mech-tip].is-open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var tip = tipOf(w);
      if (tip) {
        tip.classList.remove('is-below');
        tip.style.removeProperty('left');
        tip.style.removeProperty('top');
        tip.style.removeProperty('--tip-arrow-x');
      }
      var t = w.querySelector('[data-smelu-mech-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function place(wrap) {
    var tip = tipOf(wrap);
    var btn = wrap.querySelector('[data-smelu-mech-trigger]');
    if (!tip || !btn) return;

    // messbar machen, ohne dass sie schon sichtbar aufblitzt
    tip.style.left = '0px';
    tip.style.top = '0px';
    tip.classList.remove('is-below');

    var b = btn.getBoundingClientRect();
    var t = tip.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;

    // horizontal: auf den Kreis zentrieren, dann in den Viewport klemmen
    var anchorX = b.left + b.width / 2;
    var left = anchorX - t.width / 2;
    if (left + t.width > vw - PAD) left = vw - PAD - t.width;
    if (left < PAD) left = PAD;

    // vertikal: bevorzugt oberhalb, sonst unterhalb
    var top = b.top - GAP - t.height;
    if (top < PAD) {
      top = b.bottom + GAP;
      tip.classList.add('is-below');
      if (top + t.height > vh - PAD) top = Math.max(PAD, vh - PAD - t.height);
    }

    // Pfeil auf den Kreis ausrichten, aber innerhalb der Blase halten
    var arrow = anchorX - left;
    arrow = Math.max(14, Math.min(t.width - 14, arrow));

    tip.style.left = Math.round(left) + 'px';
    tip.style.top = Math.round(top) + 'px';
    tip.style.setProperty('--tip-arrow-x', Math.round(arrow) + 'px');
  }

  function open(wrap) {
    closeAll(wrap);
    wrap.classList.add('is-open');
    var btn = wrap.querySelector('[data-smelu-mech-trigger]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    place(wrap);
  }

  function initSection(root) {
    if (root.dataset.smeluMechInit === '1') return;
    root.dataset.smeluMechInit = '1';

    root.querySelectorAll('[data-smelu-mech-trigger]').forEach(function (btn) {
      var wrap = btn.closest('[data-smelu-mech-tip]');
      if (!wrap) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (wrap.classList.contains('is-open')) { closeAll(null); return; }
        open(wrap);
      });

      // Desktop-Hover: frueher reines CSS, mit fixed muss auch das JS platzieren
      if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
        wrap.addEventListener('mouseenter', function () { open(wrap); });
        wrap.addEventListener('mouseleave', function () { closeAll(null); });
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-smelu-mech]').forEach(initSection);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-smelu-mech-tip]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  // fixed folgt dem Scrollen nicht mit dem Anker - also schliessen.
  window.addEventListener('scroll', function () { closeAll(null); }, { passive: true });
  window.addEventListener('resize', function () { closeAll(null); }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* Aufklappbare Schritte 1-3 (26.08.2026, nur wenn steps_interactive gesetzt).
   Akkordeon: eine Zeile offen, die anderen zu. Ohne JS bleibt alles lesbar,
   weil die zugeklappte Hoehe nur per Klasse gesetzt wird. */
(function () {
  'use strict';
  function init(list) {
    var items = [].slice.call(list.querySelectorAll('.smelu-mech__step--tap'));
    if (!items.length) return;
    list.classList.add('is-ready');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-mech-step]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (o) {
          o.classList.remove('is-open');
          var b = o.querySelector('[data-mech-step]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  function boot() {
    [].slice.call(document.querySelectorAll('[data-mech-steps]')).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
